"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { Popover } from "@base-ui/react/popover";
import { forwardRef } from "react";
import { usePopoverMode } from "./PopoverContext.js";
const PopoverTrigger_PopoverTrigger = /*#__PURE__*/ forwardRef(function({ openOnHover = true, delay, closeDelay, ...props }, ref) {
    const mode = usePopoverMode();
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Trigger, {
        ref: ref,
        ...props
    });
    return /*#__PURE__*/ jsx(Popover.Trigger, {
        ref: ref,
        openOnHover: openOnHover,
        delay: delay,
        closeDelay: closeDelay,
        ...props
    });
});
export { PopoverTrigger_PopoverTrigger as PopoverTrigger };
